module.exports = __webpack_public_path__ + "media/images/point-82ba0c9c637645f479a66a3d5459167c.svg";